@if (showModal) {
<app-dialog-title>
  {{ "amend" | transloco }} {{ taxReturnAlias }}
</app-dialog-title>
@if (showChangeReason) {
<change-reason
  [taxReturn]="taxReturn"
  [showChangeCount]="true"
  actionType="amend"
  (cancel)="onClose()"
  (completed)="processTaxReturn($event); onClose(true)"
></change-reason>
} @if (!showChangeReason) {
<div>
  <mat-dialog-content class="content">
    <p>
      {{ 'are-you-sure-you-want-to-amend-the-tax-return-alias-for' | transloco: {taxReturnAlias} }}
      <b>{{ taxReturn.firstName }} {{ taxReturn.lastName }}</b
      >?
    </p>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button (click)="onClose()" class="go-back cancel btn-link">
      {{ "cancel" | transloco }}
    </button>
    <button
      (click)="processTaxReturn(); onClose(true)"
      class="ui primary button"
    >
      {{ "amend" | transloco }}
    </button>
  </mat-dialog-actions>
</div>
} }
